import { createContext } from 'react';

export const AuthContext = createContext({
  isLoggedIn: false,
  userId: null,
  email: null,
  profileImageUrl: null,
  firstName: null,
  lastName: null,
  token: null,
  login: () => {},
  logout: () => {}
});
